import request from 'local_modules/request'
import { constants } from 'helpers'
import { reducers, getState } from 'redux/core'


const setFetching = (isFetching) => reducers.marketplace.adminConfigAccessPage.setFetching(isFetching)

const fetchCashiers = () => {
  const {
    marketplace: {
      layersNavigation: {
        category: selectedCategory, area: selectedArea,
      },
    },
  } = getState()
  
  const isRpc = selectedCategory === 'rpc'
  const prefix = isRpc ? constants.rpc : constants.edu
  // const { marketplace: { layersNavigation: { toolType } } } = getState()

  // return request.get(prefix.dates + `/${toolType}?all=true`)
  return request.get(prefix.cashiersList)
    .then(({ data }) => data)
    .then((cashiers) => {
      reducers.marketplace.adminConfigAccessPage.setCashiers(cashiers)
    })
    .catch((error) => {
      console.log(error)
    })
}

const fetchSchools = () => {
  const {
    marketplace: {
      layersNavigation: {
        category: selectedCategory, area: selectedArea,
      },
    },
  } = getState()
  
  const isRpc = selectedCategory === 'rpc'
  const prefix = isRpc ? constants.rpc : constants.edu
  return request.get(prefix.schools + `?all=false`)
    .then(({ data }) => data)
    .then((schools) => {
      reducers.marketplace.adminConfigAccessPage.setSchools(schools)
    })
    .catch((error) => {
      console.log(error)
    })
}

const fetchAccess = () => {
  const {
    marketplace: {
      layersNavigation: {
        category: selectedCategory, area: selectedArea,
      },
    },
  } = getState()
  
  const isRpc = selectedCategory === 'rpc'
  const prefix = isRpc ? constants.rpc : constants.edu
  // const { marketplace: { layersNavigation: { toolType } } } = getState()

  // return request.get(prefix.dates + `/${toolType}?all=true`)
  return request.get(prefix.cashierSettings)
    .then(({ data }) => data)
    .then((access) => {
      reducers.marketplace.adminConfigAccessPage.setAccess(access)
    })
    .catch((error) => {
      console.log(error)
    })
}

const setAccess = (access) => {
  const {
    marketplace: {
      layersNavigation: {
        category: selectedCategory, area: selectedArea,
      },
    },
  } = getState()
  
  const isRpc = selectedCategory === 'rpc'
  const prefix = isRpc ? constants.rpc : constants.edu
  // const { marketplace: { layersNavigation: { toolType } } } = getState()

  // return request.post(prefix.dates + `/${toolType}?all=true`, dates)
  return request.post(prefix.cashierSettings, access)
    .then(({ data }) => data)
    .catch((error) => {
      console.log(error)
    })
}


export default {
  setFetching,
  fetchCashiers,
  fetchSchools,
  fetchAccess,
  setAccess,
}
